"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CellTypes = void 0;
/**
 * Types pour les cellules du CMS Kiosk
 * Ces types définissent la structure des props pour chaque composant
 */

/**
 * @typedef {Object} CellStylesProperties
 * @property {string} [background_color]
 * @property {string} [text_color]
 * @property {number} [text_size]
 * @property {string} [text_font]
 * @property {number} [border_radius]
 * @property {string} [border_color]
 * @property {number} [border_width]
 * @property {string} [border_style]
 * @property {number} [padding]
 * @property {number} [opacity]
 * @property {number} [hover_opacity]
 * @property {string} [text_align]
 */

/**
 * @typedef {Object} CellBaseProps
 * @property {string} id
 * @property {string} [name]
 * @property {string} [type]
 * @property {number} [index]
 * @property {number} [position_x]
 * @property {number} [position_y]
 * @property {number} [size_x]
 * @property {number} [size_y]
 * @property {CellStylesProperties} [styles_properties]
 * @property {string} [link_to]
 * @property {string} [action_log]
 * @property {string} [page_id]
 * @property {string} [className]
 * @property {Object} [style]
 * @property {Function} [onClick]
 * @property {Function} [onActionLog]
 */

/**
 * @typedef {Object} ButtonCellProps
 * @property {string} text
 * @property {string} [link_to]
 * @property {string} [action_log]
 * @property {CellStylesProperties} [styles_properties]
 * @property {string} [className]
 * @property {Object} [style]
 * @property {Function} [onClick]
 * @property {Function} [onActionLog]
 * @property {boolean} [disabled]
 */

/**
 * @typedef {Object} VideoCellProps
 * @property {string} video_uri
 * @property {boolean} [loop]
 * @property {boolean} [autoplay]
 * @property {boolean} [muted]
 * @property {boolean} [controls]
 * @property {CellStylesProperties} [styles_properties]
 * @property {string} [className]
 * @property {Object} [style]
 * @property {string} [poster]
 */

/**
 * @typedef {Object} ImageCellProps
 * @property {string} image_uri
 * @property {string} [alt]
 * @property {CellStylesProperties} [styles_properties]
 * @property {string} [className]
 * @property {Object} [style]
 * @property {string} [link_to]
 * @property {Function} [onClick]
 * @property {'cover' | 'contain' | 'fill' | 'none'} [objectFit]
 */

/**
 * @typedef {Object} IframeCellProps
 * @property {string} url
 * @property {string} [title]
 * @property {CellStylesProperties} [styles_properties]
 * @property {string} [className]
 * @property {Object} [style]
 * @property {boolean} [allowFullScreen]
 * @property {string} [sandbox]
 */

/**
 * @typedef {Object} HeaderItemProps
 * @property {string} id
 * @property {string} text
 * @property {string} [link_to]
 * @property {string} [action_log]
 * @property {CellStylesProperties} [style_properties]
 * @property {Function} [onClick]
 */

/**
 * @typedef {Object} HeaderCellProps
 * @property {HeaderItemProps[]} [items]
 * @property {CellStylesProperties} [style_properties]
 * @property {string} [className]
 * @property {Object} [style]
 * @property {string} [logoUri]
 * @property {string} [logoAlt]
 * @property {Function} [onItemClick]
 */

/**
 * @typedef {Object} HtmlCellProps
 * @property {string} html
 * @property {CellStylesProperties} [styles_properties]
 * @property {string} [className]
 * @property {Object} [style]
 * @property {boolean} [sanitize]
 */

/**
 * @typedef {Object} TextCellProps
 * @property {string} text
 * @property {CellStylesProperties} [styles_properties]
 * @property {string} [className]
 * @property {Object} [style]
 * @property {'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span'} [as]
 */

/**
 * @typedef {Object} FormFieldOption
 * @property {string} id
 * @property {string} value
 * @property {string} label
 */

/**
 * @typedef {Object} FormFieldProps
 * @property {string} id
 * @property {string} name
 * @property {string} [label]
 * @property {'text' | 'email' | 'password' | 'number' | 'tel' | 'textarea' | 'select' | 'checkbox' | 'radio'} type
 * @property {string} [placeholder]
 * @property {boolean} [required]
 * @property {number} [index]
 * @property {FormFieldOption[]} [options]
 * @property {CellStylesProperties} [style_properties]
 */

/**
 * @typedef {Object} FormCellProps
 * @property {FormFieldProps[]} [fields]
 * @property {string} [action_log]
 * @property {string} [link_to]
 * @property {CellStylesProperties} [styles_properties]
 * @property {string} [className]
 * @property {Object} [style]
 * @property {Function} [onSubmit]
 * @property {string} [submitText]
 */

/**
 * @typedef {Object} CarouselItemProps
 * @property {string} id
 * @property {'image' | 'video' | 'text'} type
 * @property {string} [image_uri]
 * @property {string} [video_uri]
 * @property {string} [text]
 * @property {CellStylesProperties} [styles_properties]
 * @property {string} [link_to]
 * @property {string} [action_log]
 */

/**
 * @typedef {Object} CarouselCellProps
 * @property {CarouselItemProps[]} items
 * @property {number} [interval]
 * @property {boolean} [loop]
 * @property {boolean} [autoplay]
 * @property {boolean} [controls]
 * @property {boolean} [indicators]
 * @property {CellStylesProperties} [styles_properties]
 * @property {string} [className]
 * @property {Object} [style]
 * @property {Function} [onSlideChange]
 */

const CellTypes = exports.CellTypes = {
  BUTTON: 'button',
  VIDEO: 'video',
  IMAGE: 'image',
  IFRAME: 'iframe',
  HEADER: 'header',
  HTML: 'html',
  TEXT: 'text',
  FORM: 'form',
  CAROUSEL: 'carousel',
  MENU: 'menu'
};